module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getAudience.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Query Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.query_name),
      expression: "gRowObj.query_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.query_name.required
    },
    attrs: {
      "type": "text",
      "id": "query_name",
      "placeholder": "Query Name"
    },
    domProps: {
      "value": (_vm.gRowObj.query_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "query_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.query_name.required) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter query name.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country_id.required
    },
    attrs: {
      "id": "country",
      "clearable": false,
      "placeholder": "--Choose a Country--",
      "multiple": false,
      "options": _vm.countryList
    },
    on: {
      "input": _vm.handleCountryChange
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country_id.required) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Folder Name")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "id": "folder",
      "clearable": true,
      "placeholder": "--Choose a Folder--",
      "multiple": false,
      "options": _vm.folderList
    },
    model: {
      value: (_vm.folderId),
      callback: function($$v) {
        _vm.folderId = $$v
      },
      expression: "folderId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Keyword Topic")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "id": "topic",
      "placeholder": "--Choose an operator--",
      "multiple": false,
      "options": _vm.topicList
    },
    on: {
      "input": _vm.handleTopicChange
    },
    model: {
      value: (_vm.gRowObj.topic_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "topic_id", $$v)
      },
      expression: "gRowObj.topic_id"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "reload-audience-builder"
  }, [_c('label', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "for": "keyword"
    }
  }, [_vm._v("Keyword(s)")]), _vm._v(" "), _c('div', {
    staticClass: "refresh-keyword"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa fa-refresh rotate",
    attrs: {
      "title": "Click to refresh the contents of the list"
    },
    on: {
      "click": function($event) {
        return _vm.refreshKeywordsList(_vm.param)
      }
    }
  })])])]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "Add Keywords",
      "multiple": true,
      "options": _vm.filteredKeywords,
      "disabled": _vm.keywordDisabled,
      "search-nested": ""
    },
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.gRowObj.keywords),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "keywords", $$v)
      },
      expression: "gRowObj.keywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-3 col-md-3 col-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "clearable": false,
      "placeholder": "--Choose an operator--",
      "multiple": false,
      "options": _vm.inNotInOptions,
      "disabled": _vm.keywordDisabled || !_vm.gRowObj.keywords.length
    },
    model: {
      value: (_vm.gRowObj.keyword_operator),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "keyword_operator", $$v)
      },
      expression: "gRowObj.keyword_operator"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "conversations"
    }
  }, [_vm._v("Conversation(s)")]), _vm._v(" "), _c('span', {
    staticClass: "ab-hint-text"
  }, [_vm._v("User has fulfilled these criteria or is currently fulfilling these criteria (ever or currently)")]), _vm._v(" "), _vm._l((_vm.gRowObj.conversations), function(conversation, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "row border-grey margin-20 padding-20 col-xs-9 col-sm-9 col-md-9"
    }, [_c('div', {
      staticClass: "form-group col-xs-8 col-sm-8 col-md-8"
    }, [_c('div', {
      staticClass: "reload-conversation-audience-builder"
    }, [_c('label', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "for": "Conversation"
      }
    }, [_vm._v("Conversation")]), _vm._v(" "), _c('div', {
      staticClass: "refresh-conversation"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('div', {
      staticClass: "fa fa-refresh rotate",
      attrs: {
        "title": "Click to refresh the contents of the list"
      },
      on: {
        "click": function($event) {
          return _vm.getConversationsList()
        }
      }
    })])])]), _vm._v(" "), _c('treeselect', {
      attrs: {
        "placeholder": "Select conversation",
        "disableBranchNodes": true,
        "multiple": false,
        "options": _vm.options,
        "disabled": _vm.conversationDisabled,
        "search-nested": ""
      },
      on: {
        "input": function($event) {
          return _vm.getStageList(conversation.conversation, index)
        }
      },
      model: {
        value: (conversation.conversation),
        callback: function($$v) {
          _vm.$set(conversation, "conversation", $$v)
        },
        expression: "conversation.conversation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-sm-3 col-md-3 col-3"
    }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('treeselect', {
      attrs: {
        "placeholder": "--Choose an operator--",
        "clearable": false,
        "multiple": false,
        "options": _vm.equalNotEqualOptions,
        "disabled": !conversation.conversation
      },
      on: {
        "input": function($event) {
          return _vm.resetStages(index, conversation.conversation_operator)
        }
      },
      model: {
        value: (conversation.conversation_operator),
        callback: function($$v) {
          _vm.$set(conversation, "conversation_operator", $$v)
        },
        expression: "conversation.conversation_operator"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      attrs: {
        "for": "stages"
      }
    }, [_vm._v("Stage(s)")]), _vm._v(" "), _vm._l((conversation.stages), function(stage, stageIndex) {
      return _c('div', {
        key: stageIndex
      }, [_c('div', {
        staticClass: "border-grey margin-20 padding-20 col-xs-9 col-sm-9 col-md-8"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group col-xs-6 col-sm-6 col-md-7 col-7"
      }, [_c('label', {
        attrs: {
          "for": "stage"
        }
      }, [_vm._v("Stage")]), _vm._v(" "), _c('treeselect', {
        attrs: {
          "id": "stage",
          "clearable": false,
          "placeholder": "--Choose a stage--",
          "multiple": false,
          "options": conversation.stageList,
          "disabled": !(conversation.conversation_operator == 4)
        },
        on: {
          "input": function($event) {
            return _vm.getAnswerList(conversation.conversation, stage.stage, index, stageIndex)
          }
        },
        model: {
          value: (stage.stage),
          callback: function($$v) {
            _vm.$set(stage, "stage", $$v)
          },
          expression: "stage.stage"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-xs-5 col-sm-5 col-md-4 col-4"
      }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('treeselect', {
        attrs: {
          "placeholder": "--Choose an operator--",
          "clearable": false,
          "multiple": false,
          "options": _vm.equalNotEqualOptions,
          "disabled": !(conversation.conversation_operator == 4 && stage.stage)
        },
        on: {
          "input": function($event) {
            return _vm.resetAnswers(index, stageIndex, stage.stage_operator)
          }
        },
        model: {
          value: (stage.stage_operator),
          callback: function($$v) {
            _vm.$set(stage, "stage_operator", $$v)
          },
          expression: "stage.stage_operator"
        }
      })], 1)]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group col-xs-6 col-sm-6 col-md-7 col-7"
      }, [_c('label', {
        attrs: {
          "for": "answer"
        }
      }, [_vm._v("Answer(s)")]), _vm._v(" "), _c('treeselect', {
        attrs: {
          "clearable": false,
          "placeholder": "--Choose an operator--",
          "multiple": true,
          "options": stage.answerList,
          "disabled": !(stage.stage_operator == 4) || !stage.answers
        },
        on: {
          "input": function($event) {
            return _vm.handleAnswerChange(index, stageIndex, stage.answers, stage.answers_operator)
          }
        },
        model: {
          value: (stage.answers),
          callback: function($$v) {
            _vm.$set(stage, "answers", $$v)
          },
          expression: "stage.answers"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-xs-5 col-sm-5 col-md-4 col-4"
      }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('treeselect', {
        attrs: {
          "clearable": false,
          "placeholder": "--Choose an operator--",
          "multiple": false,
          "options": _vm.inNotInOptions,
          "disabled": !(stage.stage_operator == 4 && stage.answers.length)
        },
        model: {
          value: (stage.answers_operator),
          callback: function($$v) {
            _vm.$set(stage, "answers_operator", $$v)
          },
          expression: "stage.answers_operator"
        }
      })], 1)])]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-remove-item btn-danger col-xs-3 col-sm-3 col-md-3 col-3 margin-top-20",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteStage(index, stageIndex)
          }
        }
      }, [_vm._v("Remove Stage")])])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addStage(index)
        }
      }
    }, [_vm._v("Add Stage")])])])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-remove-item btn-danger col-xs-2 col-sm-2 col-md-2 col-2 margin-top-20",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteConversation(index)
        }
      }
    }, [_vm._v("Remove Conversation")])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary margin-left-10 margin-bottom-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addConversation
    }
  }, [_vm._v("Add Conversation")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "conversations"
    }
  }, [_vm._v("Active Conversation (includes journeys and Jors) selection ")]), _vm._v(" "), _c('span', {
    staticClass: "ab-hint-text"
  }, [_vm._v("User is actively fulfilling these criteria (currently)")]), _vm._v(" "), _c('div', {
    staticClass: "row border-grey margin-20 padding-20"
  }, [_c('div', {
    staticClass: "form-group col-xs-8 col-sm-8 col-md-8"
  }, [_c('label', {
    attrs: {
      "for": "Conversation"
    }
  }, [_vm._v("Inclusion")]), _vm._v(" "), _c('span', [_vm._v("(when selecting multiple convos, if the user is actively engaging with any one or more convos, they will be included)")]), _vm._v(" "), _c('div', {
    staticClass: "reload-inclusion-conversation"
  }, [_c('treeselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "Select conversation",
      "disableBranchNodes": true,
      "multiple": true,
      "options": _vm.options,
      "disabled": _vm.conversationDisabled,
      "search-nested": ""
    },
    model: {
      value: (_vm.gRowObj.active_conversations_include),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "active_conversations_include", $$v)
      },
      expression: "gRowObj.active_conversations_include"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "refresh-conversation"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa fa-refresh rotate",
    attrs: {
      "title": "Click to refresh the contents of the list"
    },
    on: {
      "click": function($event) {
        return _vm.getConversationsList()
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-8 col-sm-8 col-md-8"
  }, [_c('label', {
    attrs: {
      "for": "Conversation"
    }
  }, [_vm._v("Exclusion")]), _vm._v(" "), _c('span', [_vm._v("(When selecting multiple convos, if the user actively engaging with any one or more convos, they will be excluded)")]), _vm._v(" "), _c('div', {
    staticClass: "reload-exclusion-conversation"
  }, [_c('treeselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "Select conversation",
      "disableBranchNodes": true,
      "multiple": true,
      "options": _vm.options,
      "disabled": _vm.conversationDisabled,
      "search-nested": ""
    },
    model: {
      value: (_vm.gRowObj.active_conversations_exclude),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "active_conversations_exclude", $$v)
      },
      expression: "gRowObj.active_conversations_exclude"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "refresh-conversation"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa fa-refresh rotate",
    attrs: {
      "title": "Click to refresh the contents of the list"
    },
    on: {
      "click": function($event) {
        return _vm.getConversationsList()
      }
    }
  })])])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Language(s)")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "Add Language(s)",
      "multiple": true,
      "options": _vm.languages,
      "search-nested": ""
    },
    on: {
      "input": _vm.handleLanguageChange
    },
    model: {
      value: (_vm.gRowObj.language),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "language", $$v)
      },
      expression: "gRowObj.language"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-3 col-md-3 col-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "clearable": false,
      "placeholder": "--Choose an operator--",
      "multiple": false,
      "options": _vm.inNotInOptions,
      "disabled": !_vm.gRowObj.language.length
    },
    model: {
      value: (_vm.gRowObj.language_operator),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "language_operator", $$v)
      },
      expression: "gRowObj.language_operator"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "referral"
    }
  }, [_vm._v("Referral Status")]), _vm._v(" "), _vm._l((_vm.referralOptions), function(referral) {
    return _c('div', {
      key: referral.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.referralStatus),
        expression: "gRowObj.referralStatus"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": referral.value,
        "checked": _vm._q(_vm.gRowObj.referralStatus, referral.value)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.gRowObj, "referralStatus", referral.value)
        }, _vm.checkNoteForNotOnboarded]
      }
    }), _vm._v(_vm._s(referral.label) + "\n              ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "referral"
    }
  }, [_vm._v("Reengagement/Reminder Status")]), _vm._v(" "), _vm._l((_vm.reminderOptions), function(reminder) {
    return _c('div', {
      key: reminder.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-4 col-sm-2 col-md-2 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.reminderRestriction),
        expression: "gRowObj.reminderRestriction"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": reminder.value,
        "checked": _vm._q(_vm.gRowObj.reminderRestriction, reminder.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "reminderRestriction", reminder.value)
        }
      }
    }), _vm._v(_vm._s(reminder.label) + "\n              ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "channel"
    }
  }, [_vm._v("Channel")]), _vm._v(" "), _vm._l((_vm.channelOptions), function(channel) {
    return _c('div', {
      key: channel.value
    }, [_c('label', {
      staticClass: "checkbox-inline col-xs-4 col-sm-4 col-md-3 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.channels),
        expression: "gRowObj.channels"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": channel.value,
        "checked": Array.isArray(_vm.gRowObj.channels) ? _vm._i(_vm.gRowObj.channels, channel.value) > -1 : (_vm.gRowObj.channels)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.gRowObj.channels,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = channel.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "channels", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "channels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "channels", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(channel.label) + "\n              ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "onboard"
    }
  }, [_vm._v("Onboard Status")]), _vm._v(" "), _vm._l((_vm.onboardOptions), function(onboard) {
    return _c('div', {
      key: onboard.value
    }, [_c('label', {
      staticClass: "checkbox-inline col-xs-4 col-sm-4 col-md-3 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.onboardStatus),
        expression: "gRowObj.onboardStatus"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": onboard.value,
        "checked": Array.isArray(_vm.gRowObj.onboardStatus) ? _vm._i(_vm.gRowObj.onboardStatus, onboard.value) > -1 : (_vm.gRowObj.onboardStatus)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.gRowObj.onboardStatus,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = onboard.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "onboardStatus", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "onboardStatus", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "onboardStatus", $$c)
          }
        }, _vm.checkNoteForNotOnboarded]
      }
    }), _vm._v(_vm._s(onboard.label) + "\n              ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _vm._l((_vm.genderOptions), function(gender) {
    return _c('div', {
      key: gender.value
    }, [_c('label', {
      staticClass: "checkbox-inline col-xs-4 col-sm-4 col-md-3 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.gender),
        expression: "gRowObj.gender"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": gender.value,
        "checked": Array.isArray(_vm.gRowObj.gender) ? _vm._i(_vm.gRowObj.gender, gender.value) > -1 : (_vm.gRowObj.gender)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.gRowObj.gender,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = gender.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "gender", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "gender", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "gender", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(gender.label) + "\n              ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Min Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.minAge),
      expression: "gRowObj.minAge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "minAge",
      "placeholder": "Min Age",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.gRowObj.minAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "minAge", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Max Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.maxAge),
      expression: "gRowObj.maxAge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "maxAge",
      "placeholder": "Max Age",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.gRowObj.maxAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "maxAge", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-"
  }, [_c('label', {
    attrs: {
      "for": "action-dates"
    }
  }, [_vm._v("Action Dates")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary margin-bottom-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleDateTypeChange('engagementDate')
      }
    }
  }, [_vm._v("Add Engagement Dates")]), _vm._v("   \n                "), _c('button', {
    staticClass: "btn btn-primary margin-bottom-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleDateTypeChange('OnboardedDate')
      }
    }
  }, [_vm._v("Add Onboarding Dates")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateType !== ''),
      expression: "dateType!==''"
    }],
    staticClass: "row",
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('div', {
    staticClass: "border-grey col-md-12 col-lg-6 col-xs-12 padding-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v(_vm._s(_vm.dateTypeMappings[_vm.dateType]) + " Start Date(UTC)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.dateFrom),
      expression: "gRowObj.dateFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "max": _vm.gRowObj.dateTo,
      "min": _vm.getMinDate(_vm.gRowObj.dateTo),
      "id": "date-from",
      "placeholder": "Select Start Date"
    },
    domProps: {
      "value": (_vm.gRowObj.dateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "dateFrom", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v(_vm._s(_vm.dateTypeMappings[_vm.dateType]) + " End Date(UTC)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.dateTo),
      expression: "gRowObj.dateTo"
    }],
    staticClass: "form-control",
    attrs: {
      "min": _vm.gRowObj.dateFrom,
      "max": _vm.getMaxDate(_vm.gRowObj.dateFrom),
      "type": "date",
      "id": "date-to",
      "placeholder": "Select End Date"
    },
    domProps: {
      "value": (_vm.gRowObj.dateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "dateTo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-danger col-xs-6 col-sm-6 col-md-3 col-3 margin-top-20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetDateType
    }
  }, [_vm._v("Remove")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12",
    staticStyle: {
      "margin-top": "10px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12"
  }, [_c('label', {
    staticClass: "label-custom"
  }, [_vm._v("Custom Query")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.customQuery),
      expression: "gRowObj.customQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": "Enter the custom query here"
    },
    domProps: {
      "value": (_vm.gRowObj.customQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "customQuery", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notOnboardNote),
      expression: "notOnboardNote"
    }],
    staticClass: "note-label"
  }, [_vm._v("\n      Note: Selecting the onboard status \"not onboarded\" together with an onboarded date returns no data.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Get Audience"
    }
  }), _vm._v("\n         \n      "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveAudienceData
    }
  }, [_vm._v(_vm._s(_vm.gRowObj.id ? 'Update' : 'Save') + " Audience")]), _vm._v("\n         \n      "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportAudience
    }
  }, [_vm._v("Export Audience")]), _vm._v("\n          \n      "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("Export Transcripts")]), _vm._v("\n         \n      "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(true)
      }
    }
  }, [_vm._v("Export GenAI Onboarding Transcript")]), _vm._v("\n         \n    ")])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e(), _vm._v(" "), _c('AudienceTable', {
    attrs: {
      "audienceData": _vm.audienceData,
      "audienceCount": _vm.audienceCount,
      "showTable": true
    }
  }), _vm._v(" "), (_vm.showTranscriptModal) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "230PX",
      "max-width": "600px"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Get Transcripts")])]
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label required",
      staticStyle: {
        "font-weight": "500",
        "text-align": "left"
      },
      attrs: {
        "for": "folderName"
      }
    }, [_vm._v("Type #")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transcriptNumber),
        expression: "transcriptNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.transcriptNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.transcriptNumber = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.submittedTransriptNumber && (!_vm.$v.transcriptNumber.required || !_vm.$v.transcriptNumber.minValue || !_vm.$v.transcriptNumber.maxValue)) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please enter a number between 1-100.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group pull-right",
      staticStyle: {
        "margin-right": "3px",
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeModal
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.exportTranscripts
      }
    }, [_vm._v("Submit")])])])])]
  })], 2)], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  })])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Criteria Filters:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "One account-id should be there in the custom query"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cc8a9ece","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/form.vue
// module id = IU5C
// module chunks = 1